import { Typography } from "@mui/material";
import type { StreamOutputStatsSnapshot } from "../utils/streamOutputs";

export default function WhipStatus({stats}: {stats?: StreamOutputStatsSnapshot}) {
  const w=stats?.whip;
  return <Typography component="span" variant="caption" sx={{wordBreak:"break-word"}}>
    WHIP · {stats?.publicationState || "stopped"}
    {w && <> · {w.videoCodec?.toUpperCase()} {w.videoMode}{w.encoder ? ` (${w.encoder})` : ""}
      {w.httpStatus ? ` · HTTP ${w.httpStatus}` : ""}
      {` · KLV ${w.dataChannelsAccepted ? `${w.klvChannels} channels, ${w.klvSent} sent, ${w.klvDropped} dropped` : "not negotiated"}`}
      {!w.bytesAvailable && " · Bitrate unavailable"}</>}
    {stats?.lastError && ` · ${stats.lastError}`}
  </Typography>;
}
